<template>
	<div v-if="!readonly || locations.length">
		<egranty-section-divider
			icon="gps_fixed"
			text="Współrzędne geograficzne (opcjonalnie)"
			:show-print-info="showPrintInfo"
		/>
		<div
			style="max-width: 800px"
			class="coordinates">
			<v-form ref="form">
				<v-card >
					<v-list>
						<div 
							v-for="(location, index) in locations"
							:key="index"
						>

							<v-list-tile
								class="mb-3"
								:key="index"
							>
								<v-text-field
									browser-autocomplete="off"
									class="mt-3 mr-2"
									:disabled="true"
									v-model="location.x"
									:label="readonly ? 'x' : 'x (format: 12.345(...) )'"
									aria-label="x coordinate"
									for="choose-geographocal-locations-x"
									id="choose-geographocal-locations-x"
									@input="sync"
								></v-text-field>
								<v-text-field
									browser-autocomplete="off"
									class="mt-3"
									:disabled="true"
									:label="readonly ? 'y' : 'y (format: 12.345(...) )'"
									aria-label="y coordinate"
									for="choose-geographocal-locations-y"
									id="choose-geographocal-locations-y"
									v-model="location.y"
									@input="sync"
								></v-text-field>


								<egranty-icon-button
									v-if="!readonly"
									large
									color="lightred"
									icon="delete"
									label="Usuń"
									for="choose-geographocal-locations-delete"
									id="choose-geographocal-locations-delete"
								></egranty-icon-button>

								<br>

							</v-list-tile>
							<div v-if="!readonly || location.description">
								<v-textarea style="padding: 20px"
									:disabled="true"
									class="no-print"
									browser-autocomplete="off"
									aria-label="location description"
									label="Opis lokalizacji (opcjonalnie)"
									v-model="location.description"
									outline
									@input="sync"
								></v-textarea>
								<div class="div-for-print"><p><strong style="font-size: 12px">Opis lokalizacji
									(opcjonalnie)</strong></p>{{location.description}}
								</div>
							</div>
						</div>
						<offer-button style="margin-top: 10px; margin-bottom: 10px"
							v-if="!readonly"
							text="Dodaj kolejną współrzędną"
							icon="add_location"
						></offer-button>
					</v-list>

				</v-card>
			</v-form>
		</div>
	</div>
</template>

<script>
	import OfferButton from "../../offer/components/OfferButton";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	

	export default {
		name: "ChooseGeographicalLocationsEmpty",
		components: {EgrantySectionDivider, EgrantyIconButton, OfferButton},
		methods: {
			addLocation() {
				// Nie zapisujemy, to jest tylko podgląd
				this.locations.push({
					x: "",
					y: "",
					description: "",
				});
				this.sync();
			},

			sync() {
				// Nie zapisujemy, to jest tylko podgląd
				this.$emit("input", this.locations);
			},

			deleteLocation(index) {
				// Nie zapisujemy, to jest tylko podgląd
				this.locations.splice(index, 1);
				this.sync();
			},

			validate() {
				this.error = '';
				for (let location of this.value) {
					if (this.validateLocation(location.x) !== true) {
						this.error = this.validateLocation(location.x);
						return false;
					}
					if (this.validateLocation(location.y) !== true) {
						this.error = this.validateLocation(location.y);
						return false;
					}
				}
				return this.$refs.form.validate();
			},

			validateLocation: function (value) {
				if (isNaN(value) || value === undefined || value === null || value.toString().trim() === "") {
					return "Nieprawidłowy format współrzędnych!";
				}
				return true;
			},

		},

		data() {
			return {
				locations: [{x: 0, y: 0, description: ""}],
				
			};
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val === undefined) {
						return;
					}
					this.locations = val;
				},
			},
		},

		props: {
			value: {
				type: Array,
				defaultValue: [],
			},
			readonly: {default: false},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};
</script>